<template>
  <div class="px-[30px]">
    <div v-if="!list?.length" class="content">
      <div class="my-[20px] text=font-1 font-bold">
        {{
          $t(
            'nin-ke-yi-yong-jiu-zhu-xiao-mo-fa-you-yan-ping-tai-zhang-hao-zhu-xiao-qian-qing-ren-zhen-yue-du-xia-lie-zhu-yao-ti-shi-xin-xi-zhang-hao-zhu-xiao-hou-nin-jiang-wu-fa-zai-shi-yong-gai-zhang-hao-deng-lu-mo-fa-you-yan-ping-tai-qie-zhu-xiao-hou-san-ge-yue-nei-wu-fa-shi-yong-xiang-tong-isforeign-you-xiang-shou-ji-hao-jin-hang-xin-zhang-hao-zhu-ce-de-cao-zuo-nin-que-ren-zhu-xiao-hang-wei-dai-biao-nin-jie-shou-suo-you-zhu-xiao-hou-guo-bao-kuo-dan-bu-xian-yu',
            [isGlobalVersion() ? $t('you-xiang') : $t('shou-ji-hao')]
          )
        }}
      </div>
      <div
        v-for="(item, index) in rules"
        :key="index"
        class="flex gap-[10px] mb-[20px]"
      >
        <div>
          <Resource
            class="w-[16px] h-[12px]"
            :src="getFeUrl('/youyan-platform/png/icon-delete-tip.png')"
            :transform-resource="transformImage"
          />
        </div>
        <div>
          {{ item }}
        </div>
      </div>
      <div class="text-center mt-[32px]">
        <a-checkbox v-model:checked="check">
          {{ $t('wo-yi-yue-du-bing-tong-yi') }}
          <ALink
            :href="
              !isChinese()
                ? 'https://protocol.rendora.ai/legal/delete-account'
                : 'https://frontend-protocol.xmov.ai/youyan-v3/delete-account'
            "
            name="delete"
          >
            {{ $t('mo-fa-you-yan-zhang-hao-zhu-xiao-xu-zhi') }}
          </ALink>
        </a-checkbox>
      </div>
      <!-- <div class="text-center mt-[15px] flex justify-center gap-[10px]">
          <a-button :disabled="!check" @click="cancelAccount"
            >继续注销</a-button
          >
          <a-button type="primary" @click="emits('cancel')">暂不注销</a-button>
        </div> -->
    </div>
    <div v-else>
      <div class="font-bold py-[20px]">
        {{
          $t(
            'nin-dang-qian-zhang-hao-bu-man-zu-zhu-xiao-tiao-jian-bu-man-zu-tiao-jian-ru-xia'
          )
        }}
      </div>
      <div class="details">
        <div class="flex gap-[10px]">
          <div>
            <Resource
              class="w-[16px] h-[12px]"
              :src="getFeUrl('/youyan-platform/png/icon-delete-tip.png')"
              :transform-resource="transformImage"
            />
          </div>
          <div>
            {{
              $t(
                'nin-dang-qian-jia-ru-de-qi-ye-zhang-hao-zhong-you-zhang-hao-wei-guan-li-yuan-shen-fen-qing-xian-cao-zuo-zhuan-rang-guan-li-yuan-zhang-hao-zhuan-rang-guan-li-yuan-cao-zuo-lu-jing-jin-ru-dui-ying-qi-ye-ban-zhang-hao-tuan-dui-guan-li-cao-zuo-guan-li-yuan-zhuan-rang'
              )
            }}
          </div>
        </div>
        <div
          class="mt-[30px] mb-[80px] rounded-[6px] overflow-hidden flex-col gap-[1px] flex"
        >
          <div v-for="item in list" :key="item.id" class="user-item">
            <div class="flex-1 truncate flex-y-center gap-[10px]">
              <Resource
                :src="item.logo_url"
                :transform-resource="transformImage"
                class="w-[32px] h-[32px] rounded-full avatar"
                alt="logo"
              />
              <span>
                {{ item.org_name }}
                <span class="text-font-80">({{ item.name }})</span>
              </span>
            </div>
            <div class="flex-y-center gap-[4px] text-font-80">
              <div
                class="w-[16px] h-[16px] bg-warning-6 rounded-full flex-y-center justify-center"
              >
                <iconpark-icon
                  name="icon-user-admin"
                  class="text-white text-[10px]"
                ></iconpark-icon>
              </div>
              {{ USER_ADMIN_TEXT()[item.permission] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="delete-modal-footer">
    <a-button
      v-if="list?.length"
      type="primary"
      class="w-[360px]"
      @click="emits('cancel')"
    >
      {{ $t('zhi-dao-le') }}
    </a-button>
    <template v-else>
      <a-button
        :disabled="!check"
        type="primary"
        ghost
        @click="emits('set', 'code')"
      >
        {{ $t('ji-xu-zhu-xiao') }}
      </a-button>
      <a-button type="primary" @click="emits('cancel')">
        {{ $t('zan-bu-zhu-xiao') }}
      </a-button>
    </template>
  </div>
  <!-- </a-spin> -->
</template>

<script setup lang="ts">
import type { LoginInfo } from '~/api/interface/auth'
import { USER_ADMIN_TEXT } from '~/constants'
const { $t } = useNuxtApp()

interface DeleteProps {
  list: LoginInfo[]
}
defineProps<DeleteProps>()
const check = ref(false)
const emits = defineEmits(['cancel', 'set'])

const rules = [
  $t(
    'wu-fa-deng-lu-shi-yong-ping-tai-zhang-hao-bing-yi-chu-gai-zhang-hao-xia-suo-you-shen-fen-zhang-hao-cong-yi-jia-ru-de-qi-ye-tuan-dui-zhang-hao-zhong-yi-chu'
  ),
  $t(
    'zhang-hao-tou-xiang-zhong-zhi-wei-mo-ren-tou-xiang-ni-cheng-zhong-zhi-wei-yong-hu-yi-zhu-xiao'
  ),
  $t(
    'zhang-hao-de-ge-ren-zi-liao-zuo-pin-cheng-pian-mo-ban-su-cai-deng-zi-liao-jia-ru-qi-ye-tuan-dui-zhong-de-cheng-yuan-zi-liao-yi-ji-zhang-hao-li-shi-xin-xi-deng-du-jiang-wu-fa-hui-fu'
  ),
  $t(
    'zhang-hao-nei-sheng-yu-wei-shi-yong-de-tao-can-ji-quan-yi-deng-ren-he-xu-ni-zi-chan-quan-yi-ye-jiang-bei-qing-chu-qie-wu-fa-hui-fu'
  ),
  $t(
    'zai-ping-tai-jin-hang-zhong-de-xuan-ran-dao-chu-shang-chuan-xia-zai-deng-ren-wu-jiang-bei-zhong-zhi'
  ),
]
</script>

<style lang="scss" scoped>
.delete-account {
  @apply text-font-80 px-[40px] w-full mx-auto;
  .user-item {
    @apply flex-y-center  justify-between gap-[5px] bg-back-2 px-[16px] py-[6px];
    .avatar {
      border: 1px solid var(--back-3);
    }
  }
}
</style>
